import React, { Component } from 'react';
import Auxillary from '../../hoc/Auxillary/Auxillary';
import Burger from '../../components/Burger/Burger';
import BuildControls from '../../components/Burger/BuildControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/orderSummary/orderSummary';
import axios from '../../axios-orders';
import Spinner from '../../components/UI/Spinner/Spinner';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import {connect} from 'react-redux';
import * as actionCreators from '../../store/actions/index';

const INGREDIENT_PRICES = {
    salad: 1.0,
    bacon: 0.8,
    cheese: 0.5,
    meat: 1.3
}

export class BurgerBuilder extends Component {
    state = {        
        purchaseable: false,
        purchasing: false,
        loading:false
    }

    componentDidMount(){
        this.props.defaultIngredientsHandler();                
    }

    addIngredientHandler = (type) => {
        const oldCount = this.props.ingredients[type];
        const newCount = oldCount + 1;
        const updatedIngredients = {
            ...this.props.ingredients
        }
        updatedIngredients[type] = newCount;
        const additonalPrice = INGREDIENT_PRICES[type];
        const oldPrice = this.props.totalPrice;
        const newPrice = oldPrice + additonalPrice;
        this.props.addIngredientsHandler(updatedIngredients,newPrice);
        this.updatePurchaseState(updatedIngredients);
    }
    removeIngredientHandler = (type) => {
        const oldCount = this.props.ingredients[type];
        if (oldCount <= 0)
            return;
        const newCount = oldCount - 1;
        const updatedIngredients = {
            ...this.props.ingredients
        }
        updatedIngredients[type] = newCount;
        const deductedPrice = INGREDIENT_PRICES[type];
        const oldPrice = this.props.totalPrice;
        const newPrice = oldPrice - deductedPrice;
        this.props.removeIngredientsHandler(updatedIngredients,newPrice);
        this.updatePurchaseState(updatedIngredients);
    }
    updatePurchaseState = (ingredients) => {
        const sum = Object.keys(ingredients)
            .map(igKey => {
                return ingredients[igKey]
            })
            .reduce((sum, el) => {
                return sum + el;
            }, 0);        
        this.setState({ purchaseable: sum > 0 });
    }
    purchaseHandler = () => {
        if(this.props.isAuthenticated)
            this.setState({ purchasing: true });
        else{
            this.props.setAuthRedirectPath();
            this.props.history.push('/auth');            
        }
            
    }
    purchaseCancelHandler = () =>{
        this.setState({purchasing:false});
    }
    purchaseContinueHandler = () =>{             
        this.props.onPurchaseInit();        
        this.props.history.push({
            pathname:'/checkout'
        });
    }
    
    render() {
        let burger=this.props.error?<p>Ingredients cant be fetched </p>:<Spinner/>
        let orderSummary;
        const disabledInfo = {
            ...this.props.ingredients
        }
        if(this.props.ingredients){
            orderSummary=<OrderSummary 
                totalPrice={this.props.totalPrice}
                continueOrder={this.purchaseContinueHandler} 
                cancelOrder={this.purchaseCancelHandler} 
                ingredients={this.props.ingredients} />;
            burger=<Auxillary>
                <Burger ingredients={this.props.ingredients} />
                <p>Current Price : <strong>{this.props.totalPrice.toFixed(2)}</strong></p>
                <div> <BuildControls
                    isAuthenticated={this.props.isAuthenticated}
                    ingredientAdded={this.addIngredientHandler}
                    ingredientRemoved={this.removeIngredientHandler}
                    disabled={disabledInfo}
                    purchaseable={this.state.purchaseable}
                    purchasing={this.purchaseHandler}
                /> </div>
            </Auxillary>
        }
        if(this.state.loading){
            orderSummary=<Spinner></Spinner>;
        }
        
        for (let key in disabledInfo) {
            disabledInfo[key] = disabledInfo[key] <= 0;
        }
        return <Auxillary>
            <Modal show={this.state.purchasing} modalClosed={this.purchaseCancelHandler}>
            {orderSummary}
            </Modal> 
            {burger}           
        </Auxillary>
    }
}

const mapStateToProps=state=>{
    return {
        ingredients:state.burgerBuilder.ingredients,
        totalPrice:state.burgerBuilder.totalPrice,
        error:state.burgerBuilder.error,
        purchased:state.order.purchased,
        isAuthenticated:state.auth.token!==null
    }
}

const mapDispatchToProps=dispatch=>{
    return {
        defaultIngredientsHandler:()=> dispatch(actionCreators.defIngredients()),
        addIngredientsHandler:(ing,price)=> dispatch(actionCreators.addIngredients(ing,price)),
        removeIngredientsHandler:(ing,price)=> dispatch(actionCreators.remIngredients(ing,price)),
        defaultIngredientsFailed:()=> dispatch(actionCreators.defIngredientsFailed),
        onPurchaseInit:()=>dispatch(actionCreators.purchaseInit()),
        setAuthRedirectPath:()=>dispatch(actionCreators.setAuthRedirectPath('/checkout'))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withErrorHandler(BurgerBuilder,axios));